import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
@Component({
  selector: 'app-access-denied-direct-link',
  templateUrl: './access-denied-direct-link.component.html',
  styleUrls: ['./access-denied-direct-link.component.scss']
})
export class AccessDeniedDirectLinkComponent {
  constructor(
    public dialogRef: MatDialogRef<AccessDeniedDirectLinkComponent>,
      private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: { message: string, showContactAdmin?: boolean }
  ) {}

  close(): void {
    this.dialogRef.close();
      this.router.navigate(['/index']);
  }
    onContinue(){
      this.dialogRef.close(); // your existing logic
  this.router.navigate(['/profile/membership']);
  }
}
